<template>
    <y-panel
        :title="$t('cart.title')"
        raised
        class="m-cart__cart-review mt-7"
    >
        <div slot="functions">
            <y-button
                color="primary"
                icon-prepend="pen"
                icon-size="tiny"
                size="small"
                text
                outline
                dense
                no-padding
                :content="$t('buttons.edit')"
                @click.prevent="$emit('edit')"
            />
        </div>
        <ul class="m-cart__cart-review__list">
            <li
                v-for="item in myCart"
                :key="item.id"
                class="m-cart__cart-review__item"
            >
                <y-badge
                    :content="`${digits(item.count, $i18n.locale)}x`"
                    color="primary"
                    pill
                />
                <div class="m-cart__cart-review__image">
                    <img
                        v-if="item.post_image"
                        :src="image(item.post_image, 'medium') || item.post_image.link"
                        :alt="item.ware_title"
                    >
                </div>
                <h6 class="m-cart__cart-review__title">
                    {{ item.ware_title.replace('_', '-') }}
                </h6>
            </li>
        </ul>
    </y-panel>
</template>

<script>
    import { YPanel, YBadge } from '@components';
    import { digits } from '@nodes/helpers/number';

    export default {
        name: 'CartReview',

        components: {
            YPanel,
            YBadge,
        },

        props: {
            /**
             * Wares List
             */
            myCart: {
                type: Array,
            },
        },

        methods: {
            digits,
        },
    };
</script>
